module.exports = __webpack_public_path__ + "static/aggregation-e311b8c84f5f0376dccde742e78678d3.gif";